import { useLocation, useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { EditContactDetailsForm } from "@/features/booking-history/detail/EditContactDetailsForm";
import type { Contact } from "@/types/booking-history/bookinghistorydetail";
import type { ContactValues } from "@/features/booking-history/schema/contact.schema";

export default function EditContactDetailsPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const contact = location.state?.contact as Contact | undefined;

  if (!contact) {
  return null;
}

  const contactValues: ContactValues = {
    firstName: contact.firstName,
    lastName: contact.lastName,
    email: contact.email,
    countryCode: contact.mobileNoCountryCode,
    contactMobileNo: contact.mobileNo,
  };

  return (
    <div className="max-w-7xl mx-auto px-4 pt-4 pb-16 sm:px-6 lg:px-8">
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => navigate(-1)}
          aria-label="Go back"
          className="cursor-pointer flex items-center gap-2 text-lg font-semibold text-secondary-foreground md:text-xl"
        >
          <ChevronLeft size={24} className="text-primary" />
          Edit Contact Details
        </button>
      </div>

      <div className="mt-8">
           <EditContactDetailsForm contact={contactValues} />
      </div>
    </div>
  );
}
